// eslint-disable-next-line import/prefer-default-export
export const xApiKey = 'FidrahieciWU9wQrieCY4rjODW5WGIbaeFr8Li8e';
